import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FormattedDate } from 'react-intl';
import { DateStyles } from '../../constants/CentricConstants';
import { Card, CardActions, CardHeader } from 'material-ui/Card';
import LinearProgress from 'material-ui/LinearProgress';
import FlatButton from 'material-ui/FlatButton';
import { List, ListItem } from 'material-ui/List';
import Divider from 'material-ui/Divider';

import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleMediaStore from '../../stores/ModuleMediaStore';

const getVersionItem = (previewUrl, title) => ({updateDate, course_title = '', version_id}) => (
    <ListItem
        key={version_id}
        primaryText={(<p><strong>{course_title || title} v{version_id}</strong> - <em><FormattedDate value={new Date(updateDate)} {...DateStyles.long}/></em></p>)}
    />
);

export const getModuleCode = ({mediaId}) => {
    return `MODULE${ `${mediaId}`.padStart(5, '0')}`;
};

class ModuleMediaCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            publishing: false
        };
        this.publishMedia = this.publishMedia.bind(this);
        this.mediaPublished = this.mediaPublished.bind(this);
    }

    componentWillMount() {
        this.mediaPublished();
    }

    componentDidMount() {
        this.listeners = [ ModuleMediaStore.addListener(this.mediaPublished) ];
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render() {
        const isLoading = (this.props.data.id === 'loading');

		const previewUrl = `/elearning/media/${this.props.moduleCode}/preview/${this.props.moduleId}/module`;

        return (
            <Card className="cent-card cent-card-12">
                <CardHeader
                    title={(isLoading || this.props.data.title ? 'Media' : 'Media (not published)') + (!!this.props.launchAsPopup ? ' (launch as popup)' : '')}
                    subtitle={(!!this.props.moduleCode ? `version history for ${this.props.moduleCode}` : '')}
                />
                {this.props.data.versions > 0 && (
                    <List>
                        {this.props.data.versionData
                            .sort((a, b) => b.updateDateStamp - a.updateDateStamp)
                            .map(getVersionItem(previewUrl, this.props.data.title))
                        }
                    </List>
                )}
                {(isLoading || !!this.state.publishing) && <LinearProgress/>}
                <Divider />
                <CardActions>
                    {!!this.state.publishing
                        ? <FlatButton label="Publishing..." disabled={true} />
                        : <FlatButton
                            label="Publish"
                            onTouchTap={this.publishMedia}
                            disabled={isLoading}
                            primary={true}
                        />
                    }
                    {(this.props.data.versions > 0) && (
                        <FlatButton
                            label="Preview"
                            href={previewUrl}
                            target="_blank"
                            disabled={isLoading}
                        />
                    )}
                </CardActions>
            </Card>
        );
    }

    publishMedia() {
        ModuleActions.publishModuleMedia(this.props.moduleId);

    }

    mediaPublished() {
        this.setState({publishing: ModuleMediaStore.isPublishing()});
    }
}

ModuleMediaCard.propTypes = {
    moduleCode: PropTypes.string,
    mediaId: PropTypes.number,
    moduleId: PropTypes.number.isRequired,
    launchAsPopup: PropTypes.bool,
    data: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        code: PropTypes.string,
        versions: PropTypes.number,
        versionData: PropTypes.array
    })
};

ModuleMediaCard.defaultProps = {
    launchAsPopup: false,
};


export default ModuleMediaCard;
